import { env } from 'config';
import { Merchant } from 'types';
import { apiUtils } from 'utils';

import { createCrudApi } from './crud.api';

const path = '/merchants';
const url = `${env.apiUrl}${path}`;

const getOneByUserId = async (params: { userId: string }): Promise<Merchant> =>
  (await apiUtils.getWithQueryParams(`${url}/user/${params.userId}`)).data;

const getMyInfo = async (): Promise<Merchant> =>
  (await apiUtils.getWithQueryParams(`${url}/me`)).data;

export const merchantsApi = {
  ...createCrudApi<Merchant>(path),
  getOneByUserId,
  getMyInfo,
};
